export default {
  order: {
    awaiting_payment: 'Awaiting payment',
    new: 'Waiting for confirmation',
    confirm: 'Confirmed',
    seller_update: 'Updated by seller',
    buyer_confirm_update: 'Confirmed by buyer',
    waiting_operator_confirm: 'Waiting for confirmation by operator',
    operator_confirm: 'Confirmed by operator',
    on_way: 'On way',
    operator_update: 'Updated by operator',
    buyer_confirm_operator_update: 'Waiting for confirmation by buyer',
    seller_confirm_operator_update: 'Waiting for confirmation by seller',
    received_dc: 'Received at pick-up point',
    sent_from_dc: 'On delivery',
    pickup_ready: 'Ready for pickup',
    collected: 'Collecting',
    waiting_truck: 'Waiting for transport',
    waiting_filled_truck: 'Waiting for shipment',
    filling: 'Shipping',
    filled: 'On delivery',
    deliver: 'Delivered',
    report: 'Found disperances',
    adjustment_by_admin: 'Reviewed by operator',
    seller_correct: 'Corrected',
    hold: 'On hold',
    put_on_realization: 'Put on realization',
    return_registration: 'Return registration',
    complete: 'completed',
    cancel: 'Canceled',
    operator_cancel: 'Annulled',
    request_cancelation: 'Annul request',
  },
  orderReportedItems: {
    request_created: 'Request created',
    sent_to_seller: 'Sent to seller',
    seller_received_return: 'Received by seller',
  },
  payment: {
    expected: 'Expected',
    partial: 'Partial payment',
    paid: 'Paid',
    expired: 'Outstanding',
    dispute: 'Dispute',
    failed: 'Failed',
    canceled: 'Canceled',
  },
  application: {
    new: 'New',
    open: 'Open',
    closed: 'Closed',
  },
  orderTimeline: {
    isNew: 'Order',
    isConfirmation: 'Coordination',
    isOperatorConfirm: 'Operator confirmation',
    isGoodsInTransit: 'On way',
    isReceivedDC: 'Received at pick-up point',
    isSentFromDC: 'On delivery',
    isReadyForPickup: 'Ready for pickup',
    isCollection: 'On collection',
    isDelivery: 'On delivery',
    isObtain: 'Received',
    isReport: 'Completed',
  },
  supplyRequest: {
    created: 'New',
    closed: 'Completed',
    rejected: 'Canceled',
    pending: 'On approval',
    received: 'Received',
    approved: 'Approved',
  },
  document: {
    checking: 'Checking',
    accepted: 'Accepted',
    rejected: 'Rejected',
  },
  cooperationRequest: {
    PENDING: 'New',
    REJECTED: 'Rejected',
    APPROVED: 'Approved',
    ACCEPTED: 'Accepted',
  },
}
